import ContactForm from "../components/ContactForm";

export default function ITServices() {
  return (
    <div className="p-6 max-w-5xl mx-auto">

      <h1 className="text-4xl font-bold mb-4">IT Services</h1>
<p className="text-gray-600 mb-6">
  We provide end-to-end IT solutions, from building modern web and mobile applications
  to designing scalable system architectures. Our approach is rooted in performance,
  reliability, and real-world scalability.
</p>
      <div className="grid md:grid-cols-2 gap-6 mb-10">

        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold">Website Development</h2>
          <p className="text-gray-600 mt-2">
            Responsive and modern websites for businesses.
          </p>
        </div>

        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold">Mobile Apps</h2>
          <p className="text-gray-600 mt-2">
            Android and iOS app development for your business needs.
          </p>
        </div>

        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold">System Design</h2>
          <p className="text-gray-600 mt-2">
            Scalable backend systems and architecture consulting.
          </p>
        </div>

        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold">Student Projects</h2>
          <p className="text-gray-600 mt-2">
            Real-time industry-level projects for students.
          </p>
        </div>

      </div>

<h2 className="text-2xl font-semibold mb-4">Capabilities</h2>

<ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
  <li>Full-stack web development (React, APIs)</li>
  <li>Mobile application development</li>
  <li>System design and architecture consulting</li>
  <li>Integration and automation solutions</li>
</ul>

<h2 className="text-2xl font-semibold mb-4">Our Architecture Approach</h2>

<div className="grid md:grid-cols-3 gap-4 mb-8">

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">API-First Design</h3>
    <p className="text-sm text-gray-600">Scalable and reusable backend services</p>
  </div>

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">Cloud-Ready</h3>
    <p className="text-sm text-gray-600">Designed for AWS/GCP deployment</p>
  </div>

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">Performance Focus</h3>
    <p className="text-sm text-gray-600">Optimized for reliability and scale</p>
  </div>

</div>
<h2 className="text-2xl font-semibold mb-4">What You Get</h2>

<ul className="list-disc pl-6 text-gray-600 mb-8 space-y-2">
  <li>Production-ready applications</li>
  <li>Scalable system architecture</li>
  <li>Reduced operational complexity</li>
  <li>Faster time to market</li>
</ul>
      {/* CTA */}
      <div className="bg-gray-100 p-6 rounded">
        <h2 className="text-2xl font-semibold mb-2">Need a digital solution?</h2>
        <p className="text-gray-600 mb-4">
          Let’s build something scalable and efficient together.
        </p>

        <ContactForm />
      </div>

    </div>
  );
}
